export default "__VITE_ASSET__Cdtcyikk__"